export const getBgColor = (score: number) => {
  const value = Math.floor(score / 10)

  return value - 2 >= 0 ? value - 2 + 1 : 1
}
